import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

// Capture a rendered MatchReport DOM node and save it as a multi-page A4 PDF.
export async function downloadMatchReportPdf(node, filename = 'match-report.pdf') {
  if (!node) return;
  const canvas = await html2canvas(node, { backgroundColor: '#ffffff', scale: 2, logging: false, useCORS: true });
  const imgData = canvas.toDataURL('image/png');
  const pdf = new jsPDF('p', 'pt', 'a4');
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();
  const imgW = pageW;
  const imgH = (canvas.height * imgW) / canvas.width;
  let heightLeft = imgH;
  let position = 0;
  pdf.addImage(imgData, 'PNG', 0, position, imgW, imgH);
  heightLeft -= pageH;
  while (heightLeft > 0) {
    position -= pageH;
    pdf.addPage();
    pdf.addImage(imgData, 'PNG', 0, position, imgW, imgH);
    heightLeft -= pageH;
  }
  pdf.save(filename);
}
